export function formatCentsToDollars(cents) {
  return cents / 100;
}